/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseImpact } from '../../models/response-impact';

export interface ListImpactsForActivityById$Params {
  id: number;
}

export function listImpactsForActivityById(http: HttpClient, rootUrl: string, params: ListImpactsForActivityById$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseImpact>>> {
  const rb = new RequestBuilder(rootUrl, listImpactsForActivityById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseImpact>>;
    })
  );
}

listImpactsForActivityById.PATH = '/rest/impact/activity/{id}';
